export const LoginStates = {
    EMAIL: 'Email',
    OTP: 'OTP',
}